import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaWallet } from "react-icons/fa";
import userAxiosInstance from "../../../config/userAxiosInterceptor";

const UserProfile = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        const response = await userAxiosInstance.post("/app/fetchDetails");
        setUser(response.data.details); // Adjust according to actual backend response
      } catch (error) {
        console.error("Failed to fetch user details", error);
        alert(error.message);
      }
    };

    fetchUserDetails();
  }, []);

  if (!user) return <div style={{ textAlign: "center", marginTop: "2rem" }}>Loading...</div>;

  return (
    <div
      style={{
        maxWidth: "600px",
        margin: "40px auto",
        padding: "20px",
        borderRadius: "16px",
        boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {/* Profile Picture */}
        <div style={{ flex: "0 0 100px", marginRight: "20px" }}>
          <img
            src={user.picture || "/default-avatar.png"}
            alt="Profile"
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        </div>

        {/* Basic Info */}
        <div style={{ flex: "1", minWidth: "200px" }}>
          <h2 style={{ fontSize: "24px", fontWeight: "bold", margin: "0 0 8px" }}>{user.username}</h2>
          <p style={{ color: "#666", margin: "0 0 4px" }}>{user.name}</p>
          <p style={{ color: "#666", margin: "0 0 8px" }}>{user.bio}</p>

          {/* Tags & Level */}
          <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
            {user.level_image && (
              <img
                src={user.level_image}
                alt="Level"
                style={{ width: "60px", height: "30px", borderRadius: "10%" }}
              />
            )}
            {user?.myTag?.image && (
              <img
                src={user.myTag.image}
                alt="Tag"
                style={{ width: "30px", height: "30px", borderRadius: "50%" }}
              />
            )}
          </div>

          {/* Coins */}
          <p style={{ color: "#333", fontWeight: "500" }}>⭐ Stars: {user.coin}</p>
          <p style={{ color: "#333", fontWeight: "500" }}>🪙 M-Coins: {user.recievingCoins}</p>
        </div>

        {/* Wallet Icon */}
        <div style={{ marginLeft: "10px", display:"flex" }} onClick={() => navigate("/user/pricing")}>
            Go to wallet
          <FaWallet
            title="Go to Wallet"
            style={{ fontSize: "24px", color: "#3b82f6", cursor: "pointer",marginLeft:"10px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
